import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {isAuthed} from "@irati/auth/services/whoami"
import {AuthedCheckerContext} from "../AuthedChecker"

export default class SetAuthStatus extends PureComponent {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onFail: PropTypes.func.isRequired
  }

  load = null

  checkToken = (load) => {
    if (load !== this.load) {
      this.load = load
      load.then(() => {
        isAuthed()
          .then(this.props.onSuccess)
          .catch(this.props.onFail)
      })
    }
  }

  render() {
    return (
      <AuthedCheckerContext.Consumer>
        {({load}) => this.checkToken(load)}
      </AuthedCheckerContext.Consumer>
    )
  }
}
